import script from "./UserRoleBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRoleBadge.vue?vue&type=script&setup=true&lang=js"

import "./UserRoleBadge.vue?vue&type=style&index=0&id=cab922c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cab922c8"]])

export default __exports__